// extracted by mini-css-extract-plugin
export default {"articleBox":"index_articleBox_6mBbT","end":"index_end_1O-ki"};